import React from 'react';
import {render} from 'react-dom';
import { IntlProvider } from 'react-intl';
import head from 'client/partials/_head';
import closest from 'utils/closest';
import LocaleWrapper from 'client/locale-wrapper';

render(
  <LocaleWrapper />,
  document.getElementById('app')
);



// WEBPACK FOOTER //
// ./src/index.js